import styles from './BulkEditInventoryQuantitiesModal.module.scss';
import React from 'react';
import { MAX_INVENTORY_QUANTITY_TO_SET } from './constants';

export default function InventoryWarnings({ variantsWithDetails, selectedQuantity }) {
  if (selectedQuantity === null) return null;

  const quantity = Number(selectedQuantity);

  if (Number.isNaN(quantity)) {
    return renderValidationError('amount must be a number');
  }

  if (quantity > MAX_INVENTORY_QUANTITY_TO_SET) {
    return renderValidationError(`The max quantity allowed is ${MAX_INVENTORY_QUANTITY_TO_SET}`);
  }

  if (quantity !== Math.floor(quantity)) {
    return renderValidationError('Only whole numbers are allowed');
  }

  if (quantity === 0) {
    return renderWarning('This will remove the stock for the selected SKUs at your sales channel(s).');
  }

  const isReducingQuantityOfAtLeastOneVariant = (variantsWithDetails ?? []).some(
    (variant) => quantity < variant.available_inventory,
  );

  if (isReducingQuantityOfAtLeastOneVariant) {
    return renderWarning('This will reduce the inventory level of at least one of the selected SKUs.');
  }

  return null;
}

const renderWarning = (text) => <div className={styles.validationWarning}>⚠️ {text}</div>;
const renderValidationError = (text) => <div className={styles.validationWarning}>⛔ {text}</div>;
